import type * as DynamakerContract from '../integration/DynamakerContract'

/*
  ** Internal helper called just prior to requests to Scensum (prices and add to cart) **

  - Will merge _default_ articles if sku is identical
    (this is however already done by DM)
  - Merges _mallis_ articles if sku in comination with list of chosenValues,
    regardless of sort order, is identical
    (this is _not_ done by DM)
*/
export function getAccumulatedBom(bom: DynamakerContract.BOM): DynamakerContract.BOM {
  const accumulatedBom = bom.map((section) => {
    const obj = section.articles.reduce(
      (accObj, article) => {
        const id =
          'configData' in article && article.configData
            ? `${article.erpItemNumber}:${JSON.stringify(JSON.parse(JSON.stringify(article.configData.chosenValues)).sort())}`
            : article.erpItemNumber

        if (accObj[id]) {
          accObj[id].quantity += article.quantity
        } else {
          accObj[id] = JSON.parse(JSON.stringify(article))
        }

        return accObj
      },
      {} as Record<string, DynamakerContract.ConfigurationSectionArticle>
    )

    const accumulatedArticles = Object.values(obj)

    return { ...section, articles: accumulatedArticles }
  })

  return accumulatedBom
}
